<div class="item-comment-dialog">
  <div class="modal-header d-flex align-items-start justify-content-between">
    <div>
      <span class="item-comment-dialog__context">{{ 'Comment' | translate }}</span>
      <h3 class="item-comment-dialog__title">{{ data.itemName }}</h3>
    </div>
    <button type="button" class="item-comment-dialog__close" (click)="cancel()" [attr.aria-label]="'Close' | translate">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </div>

  <div class="modal-body-content">
    <textarea
      class="item-comment-dialog__input nunito"
      [(ngModel)]="comment"
      [readonly]="data.readOnly"
      [maxlength]="maxLength"
      rows="5"
      placeholder="{{ 'Example: did not finish the meal, ate only half' | translate }}"></textarea>
    <div class="item-comment-dialog__counter nunito" *ngIf="!data.readOnly">
      {{ comment.length }}/{{ maxLength }}
    </div>
  </div>

  <div class="modal-footer-content d-flex align-items-center justify-content-end">
    <button type="button" class="item-comment-dialog__cancel pointer" (click)="cancel()">
      {{ (data.readOnly ? 'Close' : 'Cancel') | translate }}
    </button>
    <button type="button" class="item-comment-dialog__save pointer" *ngIf="!data.readOnly" (click)="save()">
      {{ 'Save' | translate }}
    </button>
  </div>
</div>
